// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"47997e07","977":"3ab626d1"}[chunkId] + ".chunk.js";
};